import { NavLink, Outlet } from 'react-router-dom';
import { useSession } from '../session';
import { useSubscription } from '../api/hooks';

const NAV = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/analytics', label: 'Analytics' },
  { to: '/sites', label: 'Sites' },
  { to: '/inventory', label: 'Inventory' },
  { to: '/managers', label: 'Managers' },
  { to: '/owners', label: 'Owners' },
  { to: '/billing', label: 'Billing' },
];

export default function Shell() {
  const { user, signOut } = useSession();
  const { data: sub } = useSubscription();

  // The trial expiring under a customer is the failure this banner exists for.
  // TRIAL_DAYS defaults to 30 and there is still nowhere to pay.
  const warn = sub && sub.days_remaining !== null && sub.days_remaining <= 14;

  return (
    <div className="shell">
      <a className="skip" href="#main">Skip to content</a>
      <header className="shell__bar">
        <div className="shell__brand">
          <span className="shell__mark" aria-hidden="true" />
          BhoomiTrack
        </div>
        <nav className="shell__nav" aria-label="Sections">
          {NAV.map((n) => (
            <NavLink
              key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `shell__link${isActive ? ' shell__link--on' : ''}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="shell__right">
          <span className="muted shell__who">
            {user?.name}
            {user?.is_super_admin && <span className="pill pill--quiet shell__badge">Super Admin</span>}
          </span>
          <button className="btn btn--quiet" onClick={signOut}>Sign out</button>
        </div>
      </header>

      {warn && (
        <div className="shell__notice" role="status">
          <strong>{sub!.days_remaining} days left on your {sub!.plan === 'trial' ? 'trial' : 'plan'}.</strong>
          {/* No checkout exists. A dead "Subscribe" button is worse than an
              honest one that says call us (§2.4). */}
          <span> To continue, call <a className="shell__phone" href="tel:+917667616304">+91 76676 16304</a>.</span>
        </div>
      )}

      <main className="shell__main" id="main" tabIndex={-1}><Outlet /></main>
    </div>
  );
}
